module.exports = ".example-full-width{width:90%}\n"